import dayjs from 'dayjs';
import { i18next } from '@frontend/i18n';
import { FormConfig } from '@frontend/design-system';

const today = dayjs().format('YYYY-MM-DD');

const validateSpecificDate = ({ value }: { value: string }) => {
  if (value && dayjs(value).isBefore(dayjs(), 'day')) {
    return i18next.t('Date cannot be in the past', { ns: 'schedule-settings' });
  }
  return '';
};

export const EXCEPTION_RECURRENCE_OPTIONS = [
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'SPECIFIC_DATE', label: 'Specific Date' },
];

export type ExceptionRecurrence = (typeof EXCEPTION_RECURRENCE_OPTIONS)[number]['value'];

export const EXCEPTION_TARGET = {
  ALL: 'all',
  CHOSEN: 'chosen',
};

export type ExceptionTarget = (typeof EXCEPTION_TARGET)[keyof typeof EXCEPTION_TARGET];

const validateDaysOfWeek = ({ value }: { value: string[] }) => {
  if (!value || value.length === 0) {
    return i18next.t('Select a day of the week', { ns: 'schedule-settings' });
  }
  return '';
};

export const ruleExceptionFields = {
  recurrence: {
    type: 'dropdown',
    required: true,
    value: 'WEEKLY',
  },
  daysOfWeek: {
    type: 'multiselect',
    value: [],
    required: true,
    validator: validateDaysOfWeek,
    validateOnChange: true,
  },
  specificDate: {
    type: 'datePicker',
    value: '',
    validator: validateSpecificDate,
    validateOnChange: true,
    minDate: today,
    hidden: true,
    required: false,
  },
  isAllDay: {
    type: 'checkbox',
    value: false,
  },
  startTime: {
    type: 'time',
    value: '',
    required: true,
  },
  endTime: {
    type: 'time',
    value: '',
    required: true,
  },
  exceptionTarget: {
    type: 'radio',
    required: true,
    value: 'all',
  },
  selectedProviderIds: {
    type: 'multiselect',
    value: [],
  },
  selectedServiceIds: {
    type: 'multiselect',
    value: [],
  },
  selectedResourceIds: {
    type: 'multiselect',
    value: [],
  },
} satisfies FormConfig;

export type RuleExceptionFieldTypes = typeof ruleExceptionFields;
